import { createBrowserRouter, Navigate } from "react-router-dom";
import { AuthLayout } from "./layouts/auth-layout";
import { RootLayout } from "./layouts/root-layout";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { TestError } from "./components/test-error";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <RootLayout />,
        children: [
            {
                element: <AuthLayout />,
                children: [
                    {
                        index: true,
                        element: <Home />,
                    },
                    {
                        path: "test-error",
                        element: <TestError />,
                    },
                    // Add other protected routes here
                ],
            },
            {
                path: "login",
                element: <Login />,
            },
            {
                path: "*",
                element: <Navigate to="/" replace />,
            },
        ],
    },
]);
